/**
 * @generated SignedSource<<ac98cf9c096d64b8daeafe340a7af26a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type url_issueFieldUrlInlineEditFull_UrlInlineEditViewNew_fragmentRef$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"url_issueFieldUrlInlineEditFull_UrlInlineEditViewIsEditable_fragmentRef">;
  readonly " $fragmentType": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewNew_fragmentRef";
};
export type url_issueFieldUrlInlineEditFull_UrlInlineEditViewNew_fragmentRef$key = {
  readonly " $data"?: url_issueFieldUrlInlineEditFull_UrlInlineEditViewNew_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"url_issueFieldUrlInlineEditFull_UrlInlineEditViewNew_fragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewNew_fragmentRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewIsEditable_fragmentRef"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ]
    }
  ],
  "type": "JiraUrlField"
};

(node as any).hash = "e70af483ddd145941defdd9bbeb62107";

export default node;
